import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Input, Button, message } from "antd";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { authActions } from "_actions";
import variables from "_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import { history } from "_helpers/history";

import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import prefooter from "../../assets/img/prefooter.svg";
import { PasswordInput } from "antd-password-input-strength";
const storage = localOrSessionStore({ key: variables.REMEMBER });

function ResetPasswordPage(props) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const user = storage.getItem(variables.USER);
  const [email, setEmail] = useState(false);
  const minLevel = 0;
  const [level, setLevel] = useState(0);
  const errorMessage = t("cuenta.debil");
  const [showPasswordChanged, setShowPasswordChanged] = useState(false);
  var resetPassword = useSelector((state) => state.authReducer.reset);
  var errorResetPassword = useSelector((state) => state.authReducer.reset);
  const onFinish = (values) => {
    setLoading(true);
    dispatch(authActions.resetPassword(email, values.password, values.confirm));
  };

  useEffect(() => {

    if (user !== null && user !== undefined) {
      setEmail(JSON.parse(user).email);
    } else {
      history.push("/auth/login");
    }
  }, [user]);
  useEffect(() => {
    if (resetPassword !== undefined) {
      setShowPasswordChanged(true);
      message.success(t("login.passwordc"));
    }
  }, [resetPassword]);

  return (
    <>
      <NavbarNoLogin className="menuNavLogin" />
      <div className="containerRowLogin">
        <div className="colRegister leftLogin">
          <h1>{t("welcomea")}</h1>
        </div>
        <div className="colRegister rightLogin">
          <div className={"formLogin"}>
            <div>
              <h3>{t("login.cambiarc")}</h3>
              <div className="customTextMedium is-required">
                {t("obligatorio")}
              </div>
              <div className="centerMobile">
                <Form
                    name="normal_login"
                    className="authForm allHeightMobile"
                    layout="vertical"
                  initialValues={{
                    remember: false,
                  }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="password"
                    label={t("login.password")}
                    rules={[
                      {
                        required: true,
                        message: t("login.passwordMandatory"),
                      },
                      {
                        validator: async () => {
                          return level >= minLevel
                            ? Promise.resolve()
                            : Promise.reject(errorMessage);
                        },
                        message: errorMessage,
                      },
                    ]}
                    hasFeedback
                  >
                    <PasswordInput
                        placeholder={t("login.passwordp")}
                      onLevelChange={setLevel}
                      settings={{
                        height: 7,
                        alwaysVisible: true,
                        colorScheme: {
                          levels: [
                            "#ff4033",
                            "#fe940d",
                            "#ffd908",
                            "#cbe11d",
                            "#6ecc3a",
                          ],
                          noLevel: "lightgrey",
                        },
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirm"
                    label={t("login.passwordrep")}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: t("login.passwordMandatory"),
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(t("login.passwordmis"))
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password  placeholder={t("login.passwordrep")} />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      loading={loading}
                      htmlType="submit"
                      className="login-form-button"
                    >
                      {t("login.reset")}
                    </Button>
                    {error && <Alert message={errorMsg} type="error" />}
                  </Form.Item>
                </Form>
                <div className={"registerLogin"}>
                  <p style={{ marginBottom: 8 }}>{t("login.primera")}</p>
                  <p className={"customTextMedium"}>{t("login.crea")}</p>
                  <div>
                    <Button
                      href={"/auth/register"}
                      className="btnPrimaryWhite"
                      style={{ width: 150 }}
                    >
                      {t("home.student")}
                    </Button>
                    <Button
                      href={"/tutorAuth/register"}
                      className="btnPrimaryWhite"
                    >
                      {t("home.tutor")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="prefooter">
        <img className="prefooter-img" src={prefooter} alt={""} />
      </div>
    </>
  );
}
export default withTranslation()(ResetPasswordPage);
